module.exports = __webpack_public_path__ + "images/12go_smallc17f6636d87edbe7df3f2439169f8825.png";